import React from 'react'
import PropTypes from 'prop-types'
import { Editor as PlainTextEditor } from 'draft-js'

const SubjectEditor = props => (
  <PlainTextEditor
    editorState={props.subjectState}
    onChange={props.updateSubjectState}
    placeholder="Type subject here..."
  />
)

SubjectEditor.propTypes = {
  subjectState: PropTypes.object.isRequired,
  updateSubjectState: PropTypes.func.isRequired,
}

export default SubjectEditor



// WEBPACK FOOTER //
// ./src/components/Messages/SubjectEditor.js